module.exports = __webpack_public_path__ + "img/newvkominfo.d87d70fa.png";